import React from "react"
import {
    componentStyles,
    Box,
    Text,
    Button,
    Divider,
} from "@mallardbay/lib-react-components"
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { usePageLayout } from "~contexts/page-layout-provider"
import { TEST_IDS } from "~config/constants"

type SidebarItemGroupHeaderProps = {
    readonly label?: string | null
    readonly isCollapsed: boolean
    readonly onToggle: () => void
}

export default function SidebarItemGroupHeader({
    label,
    isCollapsed,
    onToggle,
}: SidebarItemGroupHeaderProps) {
    const styles = useStyles()
    const { isSidebarOpen } = usePageLayout()

    // Don't render the headers when closed
    if (!isSidebarOpen) {
        return (
            <Box style={styles.collapsedGroupHeader}>
                <Divider borderWidth="0.5px" />
            </Box>
        )
    }

    // We want to keep spacing instead of returning null.
    if (!label) return <Box style={styles.groupHeader} />

    return (
        <Box style={styles.groupHeader}>
            <Button
                onClick={onToggle}
                style={styles.groupButton}
                variant="ghost"
                size="sm"
                data-testid={TEST_IDS.SIDEBAR_GROUP_HEADER}
            >
                <Text style={styles.groupTitle}>{label}</Text>
                <Box
                    style={{
                        ...styles.chevron,
                        transform: isCollapsed ? "rotate(180deg)" : "",
                    }}
                >
                    <FontAwesomeIcon icon={faChevronUp} />
                </Box>
            </Button>
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        groupHeader: {
            paddingX: 3,
            paddingY: 2,
        },
        collapsedGroupHeader: {
            paddingY: 2,
        },
        groupButton: {
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            paddingX: 2,
            paddingY: 1,
            borderRadius: "md",
        },
        groupTitle: {
            fontSize: "sm",
            fontWeight: "bold",
        },
        chevron: {
            fontSize: "xs",
            transition: "transform 0.2s",
        },
    })
}
